module.exports = __webpack_public_path__ + "img/settings-photo.ba6c9897.svg";